export { InternalHandlers } from './lambdas/invoke-internal-handler/internal-handlers/types';
export var FileMimeType;
(function (FileMimeType) {
    FileMimeType["pdf"] = "application/pdf";
    FileMimeType["docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
})(FileMimeType || (FileMimeType = {}));
//# sourceMappingURL=types.js.map